<template>
  <div  class="modal" @click.self="closePremiumModal">
    <div class="modal-dialog modal-dialog-sm">
      <div class="modal-title">{{$lang.messages.only_premium.only_for_premium}}<span class="modal-close" @click="closePremiumModal"><i class="icon-close"></i></span></div>
      <div class="flex-v-center modal-content">
        <img src="../assets/img/gena-skate.svg" width="110" height="150" alt="Only premium" class="mr-2">
        <div>
          <p>{{$lang.messages.only_premium.only_premium_description}}</p>
        </div>
      </div>
      <div class="modal-footer text-right">
        <router-link to="/premiumfeatures" class="btn btn-outline">{{$lang.messages.learn_more}}</router-link>
        <button class="btn btn-main ml-1" @click.stop="showPremiumModal">{{$lang.messages.only_premium.try_premium}}</button>
      </div>
    </div>
  </div>
</template>

<script>

export default
{
  name: 'PremiumModal',
  components: {

  },
  methods: {
    openMenuItem (title) {
      this.$emit('openmenuitem', title);
    },
    closePremiumModal () {
      this.$emit('closepremiummodal');
    },
    showPremiumModal () {
      this.closePremiumModal()
      this.$emit('showpremiummodal');
    }
  }
}
</script>
